export default "/images/check-list.svg?9af4ca5ba3ff95e0d847a9ff6320fa13";